export const CHAT_TABS = {
  ALL: "all",
  FLIGHT_CHANGES: "flight_changes",
  LEADS: "leads",
}

export const TAB_FILTER_DEFAULTS = {
  [CHAT_TABS.ALL]: {
    status: "",
    date_from: null,
    date_to: null,
    state_id: 0,
    company_id: 0,
    message_theme: [],
    departament_ids: [],
    moderator_id: 0,
    search: "",
    bundle_type: "",
    page: 1,
    per_page: 15,
    bundle_id: "",
  },
  [CHAT_TABS.FLIGHT_CHANGES]: {
    status: "",
    date_from: null,
    date_to: null,
    state_id: 0,
    search: "",
    page: 1,
    per_page: 15,
    bundle_id: "",
  },
  [CHAT_TABS.LEADS]: {
    status: "",
    date_from: null,
    date_to: null,
    search: "",
    page: 1,
    per_page: 15,
    lead_id: "",
  },
}

export const TAB_FILTER_FIELDS = {
  [CHAT_TABS.ALL]: [
    "state_id",
    "departament_id",
    "message_theme",
    "status",
    "date_range",
    "search",
  ],
  [CHAT_TABS.FLIGHT_CHANGES]: ["state_id", "status", "date_range", "search"],
  [CHAT_TABS.LEADS]: ["status", "date_range", "search"],
}

export const TAB_CAPABILITIES = {
  [CHAT_TABS.ALL]: {
    canSendMessage: true,
    canFilterByDepartment: true,
    showMessageFilter: true,
    isLeads: false,
  },
  [CHAT_TABS.FLIGHT_CHANGES]: {
    canSendMessage: false,
    canFilterByDepartment: false,
    showMessageFilter: false,
    isLeads: false,
  },
  [CHAT_TABS.LEADS]: {
    canSendMessage: true,
    canFilterByDepartment: false,
    showMessageFilter: false,
    isLeads: true,
  },
}

export const TAB_ENDPOINTS = {
  [CHAT_TABS.ALL]: {
    list: "getChatNotifies",
    detail: "getChatDetail",
    anchorParam: "anchor_bundle_id",
  },
  [CHAT_TABS.FLIGHT_CHANGES]: {
    list: "getListFlightChanges",
    detail: "getFlightChangesDetail",
    anchorParam: "anchor_bundle_id",
  },
  [CHAT_TABS.LEADS]: {
    list: "getLeadNotifies",
    detail: "getLeadChatDetail",
    anchorParam: "anchor_lead_id",
  },
}

export const TAB_LABELS = {
  [CHAT_TABS.ALL]: "chat.tab_all_chats",
  [CHAT_TABS.FLIGHT_CHANGES]: "chat.tab_flight_changes",
  [CHAT_TABS.LEADS]: "chat.tab_leads",
}

export const TAB_ORDER = [CHAT_TABS.ALL, CHAT_TABS.LEADS]

// остальное без изменений...
export const PINNED_MSG =
  "Expound the actual teachings of great explorer og the truth, the master-builder of human happiness."

export const FOR_ADMIN_KEY = "for_admin"

export const STANDARD_THEME_IDS = {
  SIMPLE: "simple",
  CANCELED: "is_canceled",
  CORRECTION: "is_correction",
  NOT_CONFIRMED: "not_confirmed",
}

export const buildStandardThemes = (t, isAdmin) => [
  {
    id: STANDARD_THEME_IDS.SIMPLE,
    title: t("main.message_from_partner"),
    description: null,
  },
  {
    id: STANDARD_THEME_IDS.CANCELED,
    title: t("main.cancellation_of_reservation"),
    description: t("admin.cancellation_of_reservation_description"),
  },
  {
    id: STANDARD_THEME_IDS.CORRECTION,
    title: t("main.correction_of_reservation"),
    description: t("admin.correction_of_reservation_description"),
  },
  ...(isAdmin
    ? [
        {
          id: STANDARD_THEME_IDS.NOT_CONFIRMED,
          title: t("admin.denial_of_reservation"),
          description: t("admin.denial_of_reservation_description"),
        },
      ]
    : []),
]

export const MOTION_VARIANTS = {
  panel: {
    hidden: { x: "100%", opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 280, damping: 30, mass: 0.8 },
    },
    exit: { x: "100%", opacity: 0, transition: { type: "spring", stiffness: 320, damping: 32 } },
  },
  sidebar: {
    hidden: { x: -40, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 28, delay: 0.08 },
    },
  },
  content: {
    hidden: { x: 40, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 28, delay: 0.12 },
    },
  },
  info: {
    hidden: { x: 60, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { type: "spring", stiffness: 320, damping: 26 } },
    exit: { x: 60, opacity: 0, transition: { duration: 0.18 } },
  },
  item: {
    hidden: { x: -20, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 24, delay: 0.15 + i * 0.04 },
    }),
  },
  backdrop: {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.18 } },
  },
}
